import { render, staticRenderFns } from "./table-history.vue?vue&type=template&id=2d7f29f8&"
import script from "./table-history.vue?vue&type=script&lang=ts&"
export * from "./table-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports